var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMsPptLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMsPpt",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1420.811 1342.116c29.93-44.724 47.436-98.484 47.436-156.197 0-136.32-97.13-250.391-225.883-276.593v260.668l178.447 172.122Zm-517.27-156.197c0 155.745 126.607 282.353 282.353 282.353 57.148 0 110.23-17.28 154.73-46.645l-211.2-203.633V909.326c-128.754 26.202-225.883 140.273-225.883 276.593Zm282.353-395.295c217.976 0 395.294 177.318 395.294 395.295 0 217.976-177.318 395.294-395.294 395.294-217.977 0-395.294-177.318-395.294-395.294 0-217.977 177.317-395.295 395.294-395.295Zm169.4-564.683v451.765h451.765v1016.47H112.94V225.941h1242.353ZM677.647 677.706H338.824v112.941h338.823V677.706Zm338.824-225.882v112.94H338.824v-112.94h677.647Zm451.764-202.504 315.445 315.445h-315.445V249.32Zm402.184 242.485L1541.195 162.58c-31.51-31.51-75.219-49.581-119.717-49.581H0v1694.118h1920V611.522c0-45.176-17.619-87.755-49.581-119.717Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconMsPptLine.glyphName = 'ms-ppt';
IconMsPptLine.variant = 'Line';
IconMsPptLine.displayName = 'IconMsPptLine';
IconMsPptLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMsPptLine;
export { IconMsPptLine };